import { ForgotPasswordContainer } from "Containers/AuthContainer/ForgotPasswordContainer/ForgotPassword";

export const ForgotPassword = () => {
  return <ForgotPasswordContainer />;
};
